import HttpRequestService from "./HttpRequestService";

const GradeService = {};

const cntrlName = "grade";
const categories = "categories";

//API for get all data
GradeService.getList = function () {
  return HttpRequestService.get(cntrlName);
};

//API for get all course
GradeService.getCourseList = function () {
  return HttpRequestService.get(`${cntrlName}/course`);
};


//API for get all categories data
GradeService.getAllCategories = function () {
  return HttpRequestService.get(`${cntrlName}/${categories}`);
};

//API for accept student
GradeService.postPaymentConfirmationMail = function (body) {
  return HttpRequestService.post(`PaymentConfirmationMail?email=${body.email}&name=${body.name}&amount=${body.amount}`);
};

GradeService.postRegistrationCompleted = function (body) {
   return HttpRequestService.post(`send-registration-completed?email=${body.email}&name=${body.name}`)
}

export default GradeService;
